import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../page/Home/Share/Footer/Footer';
import NavBar from '../page/Home/Share/NavBar/NavBar';

const Main = () => {
    return (
        <div data-theme="light" className='max-w-screen-xl mx-auto'>
            <NavBar></NavBar>
            <Outlet></Outlet>
            <Footer></Footer>
        </div>
    );
};

export default Main;